import { Component, OnInit, Inject, } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, Validators, FormControl, FormGroup } from '@angular/forms';
import { RicercaPraticheService } from 'src/app/services/ricerca-pratiche.service';

@Component({
  selector: 'app-search-documento-protocollato-modal',
  templateUrl: './search-documento-protocollato-modal.component.html',
  styleUrls: ['./search-documento-protocollato-modal.component.scss']
})
export class SearchDocumentoProtocollatoModalComponent implements OnInit {

  public searchDocumentoProtocollatoFormComponent: FormGroup = this.formBuilder.group({
    tipo: [null],
    anno: [null],
    numero: [null]
  });

  public documenti: FormControl = new FormControl(null, Validators.required);

  public showTable = false;
  public showNoResults = false;
  datasource = [];
  displayedColumns: string[] = ['nome', 'num. doc.', 'tipo', 'anno', 'numero', ' '];
  public docLoaded = [];

  ngOnInit() {}

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<SearchDocumentoProtocollatoModalComponent>,
    private ricercaPraticheService: RicercaPraticheService,
    @Inject(MAT_DIALOG_DATA) public data: { header: string, isPersonaFisica: boolean, text: string, modalParam: any}) {
  }

  getColumns() {
    return this.displayedColumns;
  }

  loadDocumentoData(index) {
    this.dialogRef.close(this.docLoaded[index]);
  }

  searchDocumento() {
    const documento = this.searchDocumentoProtocollatoFormComponent.getRawValue();
    this.ricercaPraticheService.findDocumento(documento).toPromise().then( response => {
      this.datasource = response.content.map((doc) => {
        return {
          nome : doc.nome,
          'num. doc.': doc.numDocumento,
          tipo: doc.tipo,
          anno: doc.anno,
          numero: doc.numero,
          ' ': 'loadData'
        };
      });
      this.showTable = this.datasource.length > 0;
      this.showNoResults = this.datasource.length === 0;
      this.docLoaded = response.content;
    });
  }

}
